import logo from "../../assets/images/cti3_Icon_Light_XS.png";
import { Spinner } from "@cti-workspace/ui";

export default function RenderLoadView({ color = "" }) {
	return (
		<div
			style={{
				display: "flex",
				width: "100%",
				height: "40vh",
				alignItems: "center",
				justifyContent: "center",
				flex: 1,
			}}>
			<Spinner color={color} />
		</div>
	);
}
